module.exports = __webpack_public_path__ + "assets/img/shopdefault.6699b6bd.png";